import React, { Component } from 'react'
import { Layout, Row, Col, Menu, Button, List, Card, Pagination, Popconfirm } from 'antd'
import { Link, Redirect } from 'react-router-dom'
import Head from '../../components/Head'
import ICP from '../../components/ICP'
import Foote from '../../components/Footer'
import Iconz from '../../components/Iconz'
import XZS from '../../components/XZS'
import underscore from 'underscore'
import utils from '../../utils'
import { api, app } from '../../app'
import config from '../../config'
import common from './common'

const { Content } = Layout
const order_state = common.order_state

class MOrderList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menu_current: '10',
            orderList: [],
            page: 1,
            total: 1,
        }
    }

    componentDidMount() {
        this._isMounted = true
        this.DataList(1)
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 处理按钮组
     * @param orders_id
     * @param type
     * @param orders_no
     * @returns {*}
     */
    checkOrderBtn(orders_id, type, orders_no) {
        const { action_loading } = this.state
        switch (type) {
            case '0':
                return (<Button type="primary" onClick={() => this.handlePay(orders_no)}>去支付</Button>)
            case '5':
                // return (<Button type="primary">提醒发货</Button>);
                return null
            case '3':
                return (<Button type="primary" loading={action_loading}
                    onClick={() => this.handleConfirmOrder(orders_id)}>确认收货</Button>)
        }
        return null
    }

    /**
     * 支付
     * @param orders_no
     * @returns {Promise<boolean>}
     */
    handlePay = async (orders_no) => {
        let flag = await common.pay2(orders_no)
        if (flag) {
            await this.setData({ page: 1 })
            await this.DataList(1)
        }

    }

    /**
     * 取消
     * @param orders_no
     * @returns {Promise<boolean>}
     */
    handleCancel = async (orders_id) => {
        await common.cancel(orders_id)
        app.alert('取消成功', 'success')
        await this.setData({ page: 1 })
        await this.DataList(1)
    }

    /**
     * 确认收货
     * @returns {boolean}
     */
    handleConfirmOrder = async (orders_id) => {
        app.alert('确认收货中...', 'loading', '45%', 0)
        const params = {
            orders_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, msg } = await app.post(api.MyOrdersConfirmReceipt, params)
        app.alertDestroy()
        if (flag === 1) {
            app.alert('确认成功', 'success')
            await this.setData({ page: 1 })
            await this.DataList(1)
        } else {
            app.alert(msg, 'warn')
        }
    }

    /**
     * 数据
     * @param page
     */
    DataList = async (page) => {
        await this.setData({ data_loading: true })
        const { menu_current } = this.state, params = {
            page,
            status: menu_current,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total = 0 } = await app.post(api.MyOrdersList, params)
        if (flag !== 1) {
            app.alert(msg, 'warn')
            data = []
        }
        if (this.state.page === page) {
            await this.setData({ orderList: utils.addArrayKey(data), total: parseInt(total || 0), data_loading: false })
        }
    }

    /**
     * 菜单点击
     * @param e
     */
    handleMenuClick = async (e) => {
        await this.setData({ menu_current: e.key, page: 1 })
        await this.DataList(1)
    }

    /**
     * 分页
     *
     **/
    handlePageChange = async (page) => {
        await this.setData({ page })
        await this.DataList(page)
    }

    render() {
        let isLogin = app.checkLogin()
        if (isLogin) {
            return (<Redirect to="/" />)
        } else {
            let { orderList, data_loading, menu_current, total, page } = this.state,
                { history } = this.props
            return (
                <Layout className='mall-order-list'>
                    <Head notLogin={(
                        <div className="frame-head-logo">
                            <Iconz type="icon-logo_" size={48} />
                        </div>
                    )} background="#3F89C1" height={78} history={history} />
                    <Content>
                        <div className="order-content">
                            <div className="order-menu">
                                <Menu
                                    onClick={this.handleMenuClick}
                                    selectedKeys={[menu_current]}
                                    mode="horizontal"
                                >
                                    {
                                        order_state.map((os) => {
                                            return ['4', '6', '7', '8'].indexOf(os.id) > -1 ? null : (
                                                <Menu.Item key={os.id}>{os.name}</Menu.Item>)
                                        })
                                    }
                                </Menu>
                            </div>
                            {/*<div className="order-filter">*/}
                            {/*<Input.Search placeholder="输入商品标题或订单号进行搜索" enterButton={<Button>订单搜索</Button>}/>*/}
                            {/*</div>*/}
                            <List
                                size="small"
                                header={
                                    <Row className="list-head" gutter={10} type="flex">
                                        <Col style={{ width: '40%' }}>商品</Col>
                                        <Col style={{ width: '10%' }}>单价</Col>
                                        <Col style={{ width: '10%' }}>数量</Col>
                                        <Col style={{ width: '10%' }}>实付款</Col>
                                        <Col style={{ width: '15%' }}>交易状态</Col>
                                        <Col style={{ width: '15%' }}>交易操作</Col>
                                    </Row>
                                }
                                locale={{ emptyText: '您还没有订单' }}
                                footer={
                                    <div className="pagination">
                                        <Pagination size="small" total={total} pageSize={20}
                                            current={page}
                                            hideOnSinglePage={true}
                                            showTotal={(total) => `总数量：${total}`}
                                            onChange={(page) => this.handlePageChange(page)} />
                                    </div>
                                }
                                dataSource={orderList}
                                renderItem={item => {
                                    return (
                                        <List.Item>
                                            <Card
                                                title={
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                        }}
                                                        onClick={() => history.push('/mall/order-detail/' + item.orders_id)}>
                                                        <span>订单号：{item.out_trade_no}</span>
                                                        <span>{item.datetime}</span>
                                                    </div>
                                                }
                                                style={{ width: '100%' }}
                                                bodyStyle={{ padding: 0 }}
                                            >
                                                <Row className="list-content" type="flex" gutter={10}>
                                                    <Col style={{ width: 'calc(60% - 3px)' }}>
                                                        {
                                                            (item.goods_info || []).map((good, i) => {
                                                                return (
                                                                    <Row gutter={10} type="flex" key={i}
                                                                        className="good r-b"
                                                                        onClick={() => history.push('/mall/order-detail/' + item.orders_id)}>
                                                                        <Col style={{ width: '66.8%' }}>
                                                                            <Row className="good-info" type="flex">
                                                                                <div className="good-img">
                                                                                    <a href="javascript:;">
                                                                                        <img
                                                                                            src={config.imgUrl + good.localpath}
                                                                                            alt="" />
                                                                                    </a>
                                                                                </div>
                                                                                <div className="good-name">
                                                                                    <p><a
                                                                                        href="javascript:;">{good.mall_name}</a>
                                                                                    </p>
                                                                                    <p>
                                                                                        <span style={{background: good.sku_content_name == '' || good.sku_content_name == null ? '' : '#f2f2f2', padding: '2px 4px',borderRadius: '4px',display: 'inlin-block'}}>{good.sku_content_name}</span>
                                                                                    </p>
                                                                                    <p>{good.details_huopin_content}</p>
                                                                                </div>
                                                                            </Row>
                                                                        </Col>
                                                                        <Col
                                                                            style={{ width: '16.6%' }}>{good.mall_price}</Col>
                                                                        <Col
                                                                            style={{ width: '16.6%' }}>{good.mall_number}</Col>
                                                                    </Row>
                                                                )
                                                            })
                                                        }
                                                    </Col>
                                                    <Col style={{ width: '10%' }} className="r-b p-t-20"
                                                        onClick={() => history.push('/mall/order-detail/' + item.orders_id)}>{item.total_amount}</Col>
                                                    <Col style={{ width: '15%' }}
                                                        onClick={() => history.push('/mall/order-detail/' + item.orders_id)}
                                                        className="r-b p-t-20">{(item.gstatus === '0' && item.trade_status === 'TRADE_SUCCESS') ? '已付款' : (underscore.find(order_state, (os) => os.id === item.gstatus) || { name: '未知' }).name}</Col>
                                                    <Col style={{ width: '15%' }} className="r-b p-t-20">
                                                        <p>
                                                            {
                                                                item.is_cancel === '1' ? '已取消' :
                                                                    ((item.gstatus === '0' && item.trade_status === 'TRADE_SUCCESS') ? '待审核' : this.checkOrderBtn(item.orders_id, item.gstatus, item.out_trade_no))
                                                            }
                                                        </p>
                                                        <p><Link to={'/mall/order-detail/' + item.orders_id}>订单详情</Link>
                                                        </p>
                                                        <p>
                                                            {
                                                                item.gstatus === '0' && item.is_cancel === '0' && item.trade_status !== 'TRADE_SUCCESS' ?
                                                                    <Popconfirm title="是否取消订单！"
                                                                        onConfirm={() => this.handleCancel(item.orders_id)}
                                                                        okText="是" cancelText="否">
                                                                        <a href="javascript:;">取消订单</a>
                                                                    </Popconfirm> : null
                                                            }
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </List.Item>
                                    )
                                }}
                            />
                            {/*<Table loading={data_loading} columns={columns} locale={locale}*/}
                            {/*dataSource={orderList} pagination={false} size="small"/>*/}
                        </div>
                        <Foote />
                        <ICP bg="#434343" />
                    </Content>
                    <XZS />
                </Layout>
            )
        }
    }
}

export default MOrderList



// WEBPACK FOOTER //
// ./src/routes/mall/MOrderList.jsx